import { Matrix } from "../../maths/Matrix";
import { SubmitBase } from "../submit/SubmitBase";
export class WebGLCacheAsNormalCanvas {
    constructor(ctx, sp) {
        this.submitStartPos = 0;
        this.submitEndPos = 0;
        this.touches = [];
        this.submits = [];
        this.sprite = null;
        this.meshlist = [];
        this.cachedClipInfo = new Matrix();
        this.oldTx = 0;
        this.oldTy = 0;
        this.invMat = new Matrix();
        this.context = ctx;
        this.sprite = sp;
        ctx._globalClipMatrix.copyTo(this.cachedClipInfo);
    }
    startRec() {
    }
    endRec() {
    }
    isTextNeedRestore() {
        var textNeedRestore = false;
        var charRIs = this.touches;
        if (charRIs) {
            for (var ci = 0; ci < charRIs.length; ci++) {
                if (charRIs[ci].deleted) {
                    textNeedRestore = true;
                    break;
                }
            }
        }
        return textNeedRestore;
    }
    flushsubmit() {
        var curSubmit = SubmitBase.RENDERBASE;
        this.submits.forEach((subm) => {
            if (subm == SubmitBase.RENDERBASE)
                return;
            curSubmit = subm;
        });
    }
    releaseMem() {
    }
}
WebGLCacheAsNormalCanvas.matI = new Matrix();
